import {extendCrudApiByHousehold} from '@/utils/api.js';

const invalidatesMealPlanAndRecipes = (result, error, arg) => {
  const tags = [
    { type: 'MealPlanEntries', id: 'LIST', householdId: arg.householdId },
    { type: 'Recipes', id: 'LIST', householdId: arg.householdId },
  ];

  if (arg.id) {
    tags.push({ type: 'MealPlanEntries', id: arg.id, householdId: arg.householdId });
  }

  const recipeId = arg.data?.recipe_id ?? result?.data?.recipe_id;
  if (recipeId) {
    tags.push({ type: 'Recipes', id: recipeId, householdId: arg.householdId });
  }

  return tags;
};

const mealPlanApi = extendCrudApiByHousehold({
  entityNameSingular: 'MealPlanEntry',
  entityNamePlural: 'MealPlanEntries',
  entityPath: 'meal-plan-entries',
  extraTags: ['Recipes'],
  extraEndpoints: (builder) => ({
    createMealPlanEntry: builder.mutation({
      query: ({ householdId, data }) => ({
        url: `/h/${householdId}/meal-plan-entries/`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: invalidatesMealPlanAndRecipes,
    }),
    updateMealPlanEntry: builder.mutation({
      query: ({ householdId, id, data }) => ({
        url: `/h/${householdId}/meal-plan-entries/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: invalidatesMealPlanAndRecipes,
    }),
    deleteMealPlanEntry: builder.mutation({
      query: ({ householdId, id }) => ({
        url: `/h/${householdId}/meal-plan-entries/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: invalidatesMealPlanAndRecipes,
    }),
  }),
});

export const {
  useGetMealPlanEntriesQuery,
  useGetMealPlanEntryQuery,
  useUpdateMealPlanEntryMutation,
  useDeleteMealPlanEntryMutation,
  useCreateMealPlanEntryMutation,
} = mealPlanApi;
